import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

import Header from './Header';
import AddDialog from './AddDialog';
import EditVideos from './EditVideos';
import ViewVideos from './ViewVideos';

@inject('videoStore')
@observer
class Layout extends Component {
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions = () => {
    this.props.videoStore.updateWindowDimensions(window.innerWidth, window.innerHeight);
  }

  render() {
    const store = this.props.videoStore;

    return(
      <div>
        <Header /> 
        <AddDialog />
        { (store.editMode) ?
          <EditVideos /> :
          <ViewVideos />
        }
      </div>
    );
  }
}

export default Layout;


// WEBPACK FOOTER //
// ./src/components/layout.js